import { useContext, useEffect } from 'react';
import { ApplicationSizeContext } from '../context/ApplicationSize';
import { useViewportSize } from './useViewportSize';
/**
 * This hook was causing a lot of issues within applications, often the ApplicationSizeProvider was not used. Because
 * of this, this hook tries to access the ApplicationSizeContext, if it is not available it will use the hook
 * useViewportBreakpoint to get the current size.
 */
export const useApplicationSize = () => {
    const context = useContext(ApplicationSizeContext);
    const hook = useViewportSize({ ignoreChange: context !== null });
    useEffect(() => {
        if (context === null && process.env.NODE_ENV === 'development') {
            console.warn(`The ApplicationSizeProvider is missing in the tree, please add one as a direct child of the ThemeProvider.`);
        }
    }, [context]);
    if (context === null) {
        return hook;
    }
    return context;
};
